import request from "@/utils/request";

// list blogs, unrestricted by status; params: { offset, limit, status }
export const getAdminBlogListApi = (params) => {
    return request.get('/admin/blogs', {params})
};

// single blog, unrestricted by status — used to prefill the edit form
export const getAdminBlogDetailApi = (id) => {
    return request.get(`/admin/blogs/${id}`)
};

// payload: { title, content, status, postedAt, tags }
export const createBlogApi = (payload) => {
    return request.post('/admin/blogs', payload)
};

// payload: { title, content, status, tags } — omitted fields are left unchanged
export const updateBlogApi = (id, payload) => {
    return request.put(`/admin/blogs/${id}`, payload)
};

export const deleteBlogApi = (id) => {
    return request.delete(`/admin/blogs/${id}`)
};
